<template>
  <div>
    <el-dialog  :visible.sync="consignorDialog" :before-close="closeDialog" append-to-body  width="450px" title="请输入验证码">
      <div>
        <div>
          <div>
            <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
              <el-form-item label="验证码：" style="margin-top:10px;">
                <el-row>
                  <el-col :span="15">
                    <el-input
                      v-model="formLabelAlign.vfcode"
                      maxlength="4"
                      minlength="4"
                      class="loginWord"
                      @keyup.native.enter="upDown"
                    ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label-width="0px">
                <el-row style="margin-top:10px;">
                  <el-col :span="11">
                    <img :src="verifyImg" @click="refVfcode" width="150" height="45" class="c_vf" />
                  </el-col>
                  <el-col :span="6" style="margin-top:20px;">
                    <span
                      class="approval"
                      @click="refVfcode"
                      style="margin-left:5px;font-size:12px"
                    >看不清，换一张！</span>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmit">确 定</el-button>
        <el-button @click="consignorDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { queryEnterQueryVerify } from '@/api/customer/customerManage'
export default {
  data () {
    return {
      labelPosition: 'right',
      formLabelAlign: {
        vfcode: ''
      },
      dataCount: 'cuName',
      verifyUrl: '/api/verifyCode.jpg',
      verifyImg: '',
      total: 0,
      message: [],
      supplierRules: {},
      list: [],
      params: {},
      isShow: '', // 名称
      title: '',
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      content: '',
      loadingTable: false,
      consignorDialog: false,
      contractScreenCondition: [
        { label: '部门', value: 'orgName' },
        { label: '角色', value: 'roleName' },
        { label: '姓名', value: 'staffCnName' }
      ],
      withdrawalAppRuleform: {
        newValue: undefined
      }
    }
  },
  // created () {
  //   this.verifyImg = this.verifyUrl + '?d=' + new Date().getTime()
  //   // /** 兼容IE下面 回车提交生效**/
  //   const that = this
  //   document.onkeydown = function () {
  //     const key = window.event.keyCode
  //     if (key === '13') {
  //       that.onSubmit()
  //     }
  //   }
  // },
  mounted () {
    this.refVfcode()
  },
  methods: {
    closeDialog () {
      this.formLabelAlign = {
        vfcode: ''
      }
      this.consignorDialog = false
    },
    getList () {
      this.loadingTable = true
    },

    refVfcode () {
      this.verifyImg = this.verifyUrl + '?d=' + new Date().getTime()
    },

    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 发货管理退货申请提醒确认
    onUpdataState () {},

    onInitial (val, status) {
      this.dataCount = status
      this.formLabelAlign = {
        keyword: val,
        vfcode: ''
      }
      this.isShow = val
      this.consignorDialog = true
      this.getList()
      this.message = []
    },
    upDown () {
      this.onSubmit()
    },
    async onSubmit () {
      await queryEnterQueryVerify(this.formLabelAlign)
        .then((res) => {
          if (res.data.code === 200) {
            this.consignorDialog = false
            this.$emit('qrcodeDialog', this.formLabelAlign, this.isShow)
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}
</script>

<style>
.loginBox .avatar_Box {
  height: 90px;
  width: 90px;
  border-radius: 50%;
  border: 1px solid #eee;
  padding: 10px;
  box-shadow: 0 0 10px #ddd;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
}
.loginBox .avatar_Box img {
  width: 100%;
  height: 100%;
  background-color: #eee;
  border-radius: 50%;
}
.loginA {
  box-sizing: border-box;
  padding: 10px;
  margin-top: 90px;
}
.loginWord {
  letter-spacing: 10px;
}
.c_vf {
  margin-left: 30px;
  margin-right: 5px;
  border-radius: 3px;
}
.findPwd {
  margin-left: 10px;
  font-size: 12px;
}
.el-form-item {
  margin-bottom: 18px;
}

.el-input ::v-deep .el-input__inner {
  height: 28px;
}

.el-form-item ::v-deep .el-form-item__label {
  height: 28px;
  line-height: 28px;
}

.el-form-item ::v-deep .el-form-item__content {
  line-height: 28px;
}
</style>
